"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setGeolocation;
function setGeolocation(_ref) {
  var lat = _ref.lat,
      lon = _ref.lon;

  return lat + ";" + lon;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ics-browser/dist/utils/set-geolocation.js
// module id = 1607
// module chunks = 1